"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTML = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _domToReact = _interopRequireDefault(require("html-react-parser/lib/dom-to-react"));

var _fp = require("lodash/fp");

var HTML = function HTML(_ref) {
  var _ref$html = _ref.html,
      html = _ref$html === void 0 ? '' : _ref$html,
      _ref$map = _ref.map,
      map = _ref$map === void 0 ? {} : _ref$map;
  var parserOptions = {
    replace: function replace(_ref2) {
      var name = _ref2.name,
          attrs = _ref2.attribs,
          nodeChildren = _ref2.children;
      var children = null;
      if (nodeChildren) children = (0, _domToReact.default)(nodeChildren, parserOptions);
      if (!(0, _fp.has)(name, map)) return;
      var Comp = (0, _fp.getOr)((0, _fp.always)(null), name, map);
      return _react.default.createElement(Comp, (0, _extends2.default)({
        name: name
      }, attrs), children);
    }
  };
  return (0, _htmlReactParser.default)(html, parserOptions);
};

exports.HTML = HTML;